export function hasFilters() {
  var filtrosGuardados = localStorage.getItem("filtros");
  if (!filtrosGuardados) {
    return false;
  }
  filtrosGuardados = JSON.parse(filtrosGuardados);
  var timeDiff = (Date.now() - filtrosGuardados.timestamp) / (1000 * 60 * 60); // resta 1 dia
  if (timeDiff > 2) {
    // ya paso mas de un dia
    localStorage.removeItem("filtros");
    return false;
  }
  return true;
}

export function saveFilters(filters) {
  const itemData = {
    timestamp: Date.now(),
    value: JSON.stringify(filters),
  };
  console.log("no habian filtros y se guardaron");
  localStorage.setItem("filtros", JSON.stringify(itemData));
}
